import { render, staticRenderFns } from "./DriversCourses.vue?vue&type=template&id=52befcba&scoped=true&"
import script from "./DriversCourses.vue?vue&type=script&lang=js&"
export * from "./DriversCourses.vue?vue&type=script&lang=js&"
import style0 from "./DriversCourses.vue?vue&type=style&index=0&id=52befcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52befcba",
  null
  
)

export default component.exports